import styled from "styled-components";

export const VarianceDatatableWrapper = styled.div`
  height: 70vh;
  overflow: auto;
`